import React from "react";
import { Alert, AlertDescription } from "./ui/alert";
import { CircleX } from "lucide-react";

type Props = {
  title?: string;
};

const ErrorAlert = (props: Props) => {
  return (
    props.title && (
      <Alert className="bg-[#F7E4E4] mt-1.5 flex items-center text-gray-dark border border-[#FFA3A6]">
        <CircleX color="#C8102E" />
        <AlertDescription>{props.title}</AlertDescription>
      </Alert>
    )
  );
};

export default ErrorAlert;
